import styled from 'styled-components'
import FormControlLabel, {
  FormControlLabelProps,
} from '@material-ui/core/FormControlLabel'

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-left: 4px;
` as React.ComponentType<FormControlLabelProps>
